import { F0Alert } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface FinanceAlertProps {
  financialDocumentsCount: number
  bankAccountsCount: number
}

const FinanceAlert = ({ financialDocumentsCount, bankAccountsCount }: FinanceAlertProps) => {
  const items = [
    ...(financialDocumentsCount > 0
      ? [
          i18n.t(
            'settings.legal_entities.legal_entity.remove.blocked_by_finance.financial_documents',
            { count: financialDocumentsCount }
          ),
        ]
      : []),
    ...(bankAccountsCount > 0
      ? [
          i18n.t('settings.legal_entities.legal_entity.remove.blocked_by_finance.bank_accounts', {
            count: bankAccountsCount,
          }),
        ]
      : []),
  ]

  const bulletList = items.map((item) => `• ${item}`).join('\n')
  const contactMessage = i18n.t(
    'settings.legal_entities.legal_entity.remove.blocked_by_finance.contact_message'
  )
  const description = bulletList ? `${bulletList}\n${contactMessage}` : contactMessage

  return (
    <F0Alert
      variant="critical"
      title={i18n.t('settings.legal_entities.legal_entity.remove.blocked_by_finance.title')}
      description={description}
    />
  )
}

export default FinanceAlert
